import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { your } from 'src/lib/flow/text';

import { FlowContext } from '../../../../lib/flow';

function isEnabled() {
  return true;
}

function title({ answers, inputContext: { channel } }: FlowContext): string {
  return `How would you describe ${your(answers, channel)} kitchen appliances?`;
}

function subtitle({ answers, inputContext: { channel } }: FlowContext): string {
  return `This helps us understand the condition of ${your(answers, channel)} kitchen.`;
}

const kitchenAppliancePage: FlowPage = {
  slug: () => 'kitchen-appliance',
  isEnabled,
  autoAdvance: () => true,
  title,
  subtitle,
  questions: (): FlowQuestion[] => [
    {
      key: 'home.kitchen.appliance_type',
      type: 'radio_single_select',
      options: [
        {
          label: 'Stainless steel',
          value: 'stainless_steel',
        },
        {
          label: 'Black',
          value: 'black',
        },
        {
          label: 'White',
          value: 'white',
        },
        {
          label: 'Mixed finishes',
          value: 'mixed',
        },
      ],
    },
  ],
};

export default kitchenAppliancePage;
